import { useAppSelector } from "@hooks/use-store";

import { useGetAdsQuery } from "../../api/ads";

export enum BannerPosition {
  TEST_STRING = "testString",
  TEST_STRING_RESULT = "testStringResult",
  RESULT = "result",
  MAIN_LEFT = "mainLeft",
  MAIN_RIGHT = "mainRight",
  MAIN_BOTTOM = "mainBottom",
  MAIN_FULL_WIDTH = "mainFullWidth",
  FINISH_RIGHT = "finishRight",
  FINISH_LEFT = "finishLeft",
  FINISH_BOTTOM = "finishBottom",
  CHALLENGE_BOTTOM = "challengeBottom",
}

type PropsTypeAdsBanner = {
  bannerPosition: BannerPosition;
};

function AdsBanner({ bannerPosition }: PropsTypeAdsBanner) {
  const { currentAdsPage } = useAppSelector((state) => state.app);

  const { data: adsData, isLoading } = useGetAdsQuery(
    {
      page: currentAdsPage,
    },
    {
      skip: !currentAdsPage,
    },
  );

  const containerClassNames = {
    testString: "flex justify-center mt-6 md:mb-8",
    testStringResult: "flex justify-center",
    result: "flex justify-center",
    mainLeft: "hidden absolute top-[20px] -left-[55px] lg:block",
    mainRight: "hidden absolute top-[20px] -right-[55px] lg:block",
    mainBottom: "flex justify-center mb-3 md:mb-5",
    mainFullWidth: "flex justify-center mb-6 md:mb-8",
    finishLeft: "hidden absolute -top-[130px] -left-[55px] lg:block",
    finishRight: "hidden absolute -top-[130px] -right-[55px] lg:block",
    finishBottom: "flex justify-center mb-3 md:mb-5",
    challengeBottom: "flex justify-center",
  };

  if (isLoading || !adsData) {
    return null;
  }

  if (!adsData.tags[bannerPosition]) {
    return null;
  }

  return (
    <div
      className={containerClassNames[bannerPosition]}
      dangerouslySetInnerHTML={{ __html: adsData.tags[bannerPosition] }}
    />
  );
}

export default AdsBanner;
